<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} BAHAN BANGUNAN</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        
        <vs-input label="Bahan Bangunan" v-model="dataBahanBangunan" class="mt-5 w-full" name="item-bahanbangunan" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-bahanbangunan')">{{ errors.first('item-bahanbangunan') }}</span>

        <vs-row>
          <vs-col vs-align="center" vs-w="4">
            <vs-select
              label="Satuan"
              v-model="dataSatuan"
              v-validate="'required'"
              class="mt-4 w-full"
              @change="pilihSatuan"
              @click.prevent="changePilihSatuan"
              >
                <vs-select-item value="0" text="Tidak ada"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listSatuan"/>
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('satuan')">{{ errors.first('satuan') }}</span>
          </vs-col>

          <vs-col vs-align="center" vs-w="2">
            <vs-button class="py-3 mt-10" @click.stop="tambahSatuan=true" >+</vs-button>
          </vs-col>

          <vs-col vs-align="center" vs-w="6">

            <vs-input label="Harga (rupiah)" v-model="dataHarga" class="pr-2 mt-4 w-full" name="item-harga" v-validate="'required'" 
            v-currency="{
            currency: null, 
            locale: 'de',
            precision:0,
            distractionFree:false
            }"/>

            <span class="text-danger text-sm" v-show="errors.has('item-harga')">{{ errors.first('item-harga') }}</span>
          </vs-col>
        </vs-row>
        
        <vs-divider class="mt-base">Satuan Pembelian</vs-divider>

        <vs-row>
          <vs-col vs-align="center" vs-w="4">
            <vs-select
              label="Satuan Pembelian"
              v-model="dataSatuanPembelian"
              v-validate="'required'"
              class="mt-4 w-full"
              @change="pilihSatuanPembelian"
              @click.prevent="changePilihSatuanPembelian"
              >
                <vs-select-item value="0" text="Tidak ada"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listSatuan"/>
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('satuan')">{{ errors.first('satuan') }}</span>
          </vs-col>

          <vs-col vs-align="center" vs-w="2">
            <vs-button class="py-3 mt-10" @click.stop="tambahSatuan=true" >+</vs-button>
          </vs-col>

          <vs-col vs-align="center" vs-w="6">

            <vs-input label="Harga Pembelian (rupiah)" v-model="dataHargaPembelian" class="pr-2 mt-4 w-full" name="item-harga" v-validate="'required'" 
            v-currency="{
            currency: null, 
            locale: 'de',
            precision:0,
            distractionFree:false
            }"/>

            <span class="text-danger text-sm" v-show="errors.has('item-harga')">{{ errors.first('item-harga') }}</span>
          </vs-col>
        </vs-row>
        
        <vs-divider class="mt-base">Konversi Satuan</vs-divider>

        <vs-row>
          <vs-col vs-align="center" vs-w="6" class="flex pr-2 items-center">
            <vs-input label="Pembelian" v-model="dataKonversiCons" class="pr-2 mt-4 w-full" disabled/>
            {{dataNamaSatuanPembelian}}
          </vs-col>

          <vs-col vs-align="center" vs-w="6" class="flex items-center">
            <vs-input label="Bahan" v-model="dataKonversiVar" class="pr-2 mt-4 w-full" name="item-konversi" v-validate="'required'"/>
            {{dataNamaSatuan}}
          </vs-col>
          <span class="text-danger text-sm" v-show="errors.has('item-konversi')">{{ errors.first('item-konversi') }}</span>
        </vs-row>

        <vs-row>
          <vs-col vs-align="center" vs-w="6">
            <div class="vx-row">
              <div class="vx-col w-full mt-5">
                <vs-select
                  label="Group"
                  v-model="dataGroup"
                  >
                    <vs-select-item value="0" text="Tidak ada"/>
                    <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listBahanBangunan"/>
                </vs-select>
              </div>
            </div>
          </vs-col>

          <vs-col vs-align="center" vs-w="6">
            <div class="vx-row">
              <div class="vx-col w-full mt-5">
                <vs-select
                  label="Parent"
                  v-model="dataParent"
                  >
                    <vs-select-item value="0" text="Tidak ada"/>
                    <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listBahanBangunan"/>
                </vs-select>
              </div>
            </div>
          </vs-col>
        </vs-row>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>

    <vs-prompt
      color="success"
      title="Tambah Satuan"
      @accept="satuanAdd"
      @close="close"
      :active.sync="tambahSatuan"
      style="z-index: 52011;">
      <div class="con-exemple-prompt">
        <vs-input placeholder="Satuan" data-vv-name="addsatuan" name="addsatuan" v-validate="'required'" v-model="addSatuan"/>
        <span class="text-danger text-sm" v-show="errors.has('addsatuan')">{{ errors.first('addsatuan') }}</span>
       </div>
    </vs-prompt>

  </vs-sidebar>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import { CurrencyDirective } from 'vue-currency-input'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    
  },
  directives: {
    currency: CurrencyDirective
  },
  data () {
    return {

      dataId: null,
      dataBahanBangunan: null,
      dataGroup: 0,
      dataParent: 0,
      dataHarga: null,
      dataSatuan: 0,
      dataNamaSatuan: null,
      dataHargaPembelian: null,
      dataSatuanPembelian: 0,
      dataNamaSatuanPembelian: null,
      dataKonversiCons: 1,
      dataKonversiVar: 0,

      changeSatuan: false,
      changeSatuanPembelian: false,

      listBahanBangunan: [],
      listSatuan: [],

      addSatuan: null,
      tambahSatuan: false,

      settings: {
        maxScrollbarLength: 80,
        wheelSpeed: .80
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/term-list/bahan-bangunan', configs)
      .then((response) => {
        let {data} = response.data
        this.listBahanBangunan = data
      })
      .catch((error) => {
        let data = error.data
        this.listBahanBangunan = data
      })

      this.axios.get('/term-list/satuan', configs)
      .then((response) => {
        let {data} = response.data
        this.listSatuan = data
      })
      .catch((error) => {
        let data = error.data
        this.listSatuan = data
      })

      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id, name, term_group, parent, harga, satuan, satuan_pembelian, harga_pembelian, konversi  } = JSON.parse(JSON.stringify(this.data))
        let euroGerman = Intl.NumberFormat("de-DE");
        this.dataId = id
        this.dataBahanBangunan = name
        this.dataGroup = term_group
        this.dataParent = parent
        this.dataHarga = euroGerman.format(harga)
        this.dataSatuan = satuan
        this.dataSatuanPembelian = satuan_pembelian
        this.dataHargaPembelian = euroGerman.format(harga_pembelian)
        this.dataKonversiVar = konversi
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataBahanBangunan && this.dataHarga && this.dataSatuan && this.dataHargaPembelian && this.dataSatuanPembelian && this.dataKonversiVar
    },
    validateSatuan() {
      return !this.errors.any() && this.addSatuan !== null
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    }),
  },
  mounted(){
  },
  methods: {
    changePilihSatuan () {
      this.changeSatuan = true
    },
    changePilihSatuanPembelian () {
      this.changeSatuanPembelian = true
    },
    pilihSatuan() {
      if (this.changeSatuan) {
        const ItemIndex = this.listSatuan.find((satuan) => satuan.id == this.dataSatuan)
        this.dataNamaSatuan = ItemIndex.name
      }
    },
    pilihSatuanPembelian() {
      if (this.changeSatuanPembelian) {
        const ItemIndex = this.listSatuan.find((satuan) => satuan.id == this.dataSatuanPembelian)
        this.dataNamaSatuanPembelian = ItemIndex.name
      }
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataBahanBangunan = null
      this.dataGroup = 0
      this.dataParent = 0
      this.dataHarga = null
      this.dataSatuan = 0
      this.dataNamaSatuan = null
      this.dataHargaPembelian = 0
      this.dataSatuanPembelian = 0
      this.dataNamaSatuanPembelian = null
      this.dataKonversiVar = 0
    },
    close() {
      this.$emit('closed', false)
    },
    satuanAdd() {

      this.$vs.loading()
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      let formData = {
        name : this.addSatuan,
        term_group: 0,
        parent: 0,

        taxonomy: 'satuan'
      }

      this.axios.post('/term-add', formData, configs)
      .then((response) => {
        this.listSatuan = []
        this.addSatuan = null
        this.loadSatuan()

        this.$vs.notify({
          title: response.message,
          color  : 'success',
          text  : 'Satuan telah bertambah',
        })
        this.$vs.loading.close()

      })
      .catch((error) => {
        this.$vs.loading.close()
        let { data } = error.response

        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })

    },
    loadSatuan () {
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/term-list/satuan', configs)
      .then((response) => {
        let {data} = response.data
        this.listSatuan = data
      })
      .catch((error) => {
        let data = error.data
        this.listSatuan = data
      })
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.dataId,
            name: this.dataBahanBangunan,
            term_group: this.dataGroup,
            parent: this.dataParent,

            meta : {
              harga: this.dataHarga.split('.').join(""),
              satuan: this.dataSatuan,
              harga_pembelian: this.dataHargaPembelian.split('.').join(""),
              satuan_pembelian: this.dataSatuanPembelian,
              konversi: this.dataKonversiVar
            },

            taxonomy: 'bahan-bangunan'
          }

          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('bahanbangunan/updateBahanBangunan', obj)
          } else {
            delete obj.id
            this.$store.dispatch('bahanbangunan/addBahanBangunan', obj)
          }
          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 450px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
